import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import './Work.css';
import ms from '../../Assets/Work/monalis-in.png';
import e1 from '../../Assets/Work/e1.png';
import e2 from '../../Assets/Work/e2.png';
import e3 from '../../Assets/Work/e3.png';
import i1 from '../../Assets/Work/insta1.png';
import i2 from '../../Assets/Work/insta2.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import NavBar from "../Navbar";
import Footer from "../Footer";

function Lookbook() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
              <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '70s' }}>
                Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S         Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S         Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S         Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S         Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S         Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          Monali S          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={ms}
                      alt="monalis"
                      className="img-fluid"
                      style={{ padding: '0px'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>Monali S</h1>
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                  />
                  </div>
                  <p className="content">Monali S is a pret and couture clothing line for men, women and kids. An exclusive label specialising in curating flattering designs. </p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Social Media Intern, Graphic Designer</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">January, 2021 - June, 2021</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Canva, PhotoShop</p>
                    </div>
                    </Col>
                </Row>

                <Row style={{paddingBottom: "32px"}}>
                <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>MY WORK</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Carousel  slide={false} className="carousel" style={{verticalAlign: 'center'}}>
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={e2}
                          alt="First slide"
                        />
                      </Carousel.Item>
                    
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={e1}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={e3}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={i2}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={i1}
                          alt="First slide"
                        />
                      </Carousel.Item>
                
                </Carousel>
                </Col>
                </Row>
                <Row style={{paddingBottom: "20px", paddingTop:"40px"}}>
                    <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>IMPACT</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">01</p>
                      </Col>
                      <Col>
                      <p className="content">Conducted extensive research on current trends and competitors to create engaging social media content. Designed <b className="content-bold">5+ exhibition banners</b> and a <b className="content-bold">personalized <a href="https://drive.google.com/file/d/1s9ihoPGi7Zmro0LEG43arcvOuKE7iD2d/view?usp=share_link" rel="noopener noreferrer" target="_blank" style={{color: '#F9D63D'}}><b className="content-bold"> fashion lookbook.</b></a></b></p>
                      </Col>
                    </Row>
                    
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">02</p>
                      </Col>
                      <Col>
                      <p className="content">Incremented the Instagram <b className="content-bold"> follower count by 2000 in just six months</b> - through authentic means!</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">03</p>
                      </Col>
                      <Col>
                      <p className="content">Increased the <b className="content-bold">month-on-month engagement rate by at least 25%</b> thereby increasing the social reach and conversion rate.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">04</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="content-bold">Proposed and eventually established a WhatsApp business account</b> experienceing independently. This achieved great responses among the target audience and increase in product sales.</p>
                      </Col>
                    </Row>
                    
                    </Col>
                </Row>
                <Row style={{marginBottom: "100px", paddingTop:"40px",  fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/experience/kratinbranding'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                </Row>    
                
            </Container>
                </Container>
              </Col>
              </aside>
            </Row>
           
        <Footer />
      </Box>
    </section>
  );
}

export default Lookbook;
